<template>
    <div class="navbar-container">
        <nav class="navbar fixed-top mx-auto shadow-sm bg-danger">
            <div class="navbar-contents w-100">
                <div class="d-flex">
                    <img alt="" src="/img/hcpay/hcpay-logo-red.svg" class="HCPayLogo img-responsive ml-3 mr-auto">
                    <div class="d-flex align-items-center">
                        <div v-if="$root.account.personalInformation != null" class="d-none d-md-flex align-items-center">
                            <img alt="" src="/img/hcpay/user-photo-alt-white.svg" class="userPhoto img-responsive mr-3">
                            <span class="font-sm text-capitalize text-white">{{$root.account.personalInformation.firstName}} {{$root.account.personalInformation.lastName}}</span>
                            <button type="button" class="btn btn-outline-danger rounded-lg font-sm text-capitalize mx-4 px-3" @click="$root.logout()">Logout</button>
                        </div>
                        <div v-if="$root.account.personalInformation != null" class="d-flex d-md-none dropdown">
                            <img alt="" src="/img/hcpay/user-icon.svg" class="userIcon img-responsive mr-3 clickable" id="accountDropdownBtn" @click="displayAccountDropdown">
                            <account-dropdown v-if="showAccountDropdown" class="accountDropdownPosition"></account-dropdown>
                        </div>
                        <img alt="" src="/img/hcpay/help-icon.svg" class="helpIcon img-responsive mr-3 clickable" @click="changeView('help-screen')">
                    </div>
                </div>
            </div>
        </nav>
    </div>
</template>
<script>
export default {
    data() {
        return {
            showAccountDropdown: false
        }
    },
    methods:{
        changeView(view) {
            this.$root.$data.view = view;
        },
        displayAccountDropdown() {
            this.showAccountDropdown = true;
        }
    },
    created() {

    }
}
</script>
<style scoped>
    .HCPayLogo {
        width: 5%;
    }
    .helpIcon {
        height: auto;
        width: 1.5rem;
    }

    .userIcon {
        height: auto;
        width: 1rem;
    }

    .userPhoto {
        height: auto;
        width: 2rem;
    }
    .accountDropdownPosition {
        top: 2rem;
        left: -4rem;
    }

    @media (min-width: 120px) and (max-width: 767px) {
        .HCPayLogo {
            width: 60px;
        }
    }
</style>